import { render, staticRenderFns } from "./FrontendLayout.vue?vue&type=template&id=2cc987b8&scoped=true"
import script from "./FrontendLayout.vue?vue&type=script&lang=js"
export * from "./FrontendLayout.vue?vue&type=script&lang=js"
import style0 from "./FrontendLayout.vue?vue&type=style&index=0&id=2cc987b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc987b8",
  null
  
)

export default component.exports